




import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class EqualFieldsValidator extends Vue {
  @Prop() readonly name1!: string;
  @Prop() readonly value1!: string;
  @Prop() readonly name2!: string;
  @Prop() readonly value2!: string;

  public getMessage (): string {
    return this.name1 + ' and ' + this.name2 + ' do not match';
  }

  public getValidationClass (): string {
    return this.value1 !== this.value2 ? 'field-validation-error' : 'field-validation-valid';
  }
}
